import { VariantProps } from 'class-variance-authority';
import { buttonVariants } from '@/components/ui/button';

type ButtonVariantProps = VariantProps<typeof buttonVariants>;
type ButtonVariant = NonNullable<ButtonVariantProps['variant']>;

export interface SimpleMenuItem {
  label: string;
  href?: string;
}

export interface ServiceCardInfo {
  imgSrc: string;
  title: string;
  descrition: string;
  href: string;
}

export interface ExtraMenuService {
  cardInfo?: ServiceCardInfo;
  instructions: SimpleMenuItem[];
}

interface ExtraMenuItems {
  variant?: ButtonVariant;
  className?: string;
}

export type ServiceMenuItem = SimpleMenuItem & ExtraMenuService;

export interface ExpandableMenuItem {
  label: string;
  services: ServiceMenuItem[];
}

export type MenuItem = (ExpandableMenuItem | SimpleMenuItem) & ExtraMenuItems;

export interface ActionMenuItem extends SimpleMenuItem {
  variant: 'ghost' | 'outline' | 'secondary';
  className?: string;
}

export function isSimpleMenuItem(item: MenuItem): item is SimpleMenuItem {
  return 'label' in item && 'href' in item;
}

export function isExpandableMenuItem(
  item: MenuItem
): item is ExpandableMenuItem {
  return 'label' in item && 'services' in item;
}

export interface BLOG_ITEM {
  tag: string;
  title: string;
  description: string;
  img_src: string;
}

export interface TESTIMONY_ITEM {
  testimony: string;
  img_src: string;
  name: string;
  ocupation: string;
}
